import React, { useContext, useEffect, useState } from "react";
import { CartContext, LocationsContext } from "../../context";
import PhoneInput from "react-phone-number-input";
import _ from "lodash";
import { useTrans } from "../../hooks";
import phoneValidation from "../../utils/phoneValidation";

const UpdateCheckoutPhone = () => {
  const transMsg = useTrans();
  const { cartPhone, setCartPhone } = useContext(CartContext);
  const [defaultCountry, setDefaultCountry] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const { selectedLocation } = useContext(LocationsContext);
  useEffect(() => {
    if (_.isEmpty(selectedLocation?.address?.countryCode)) return;

    const countryCode =
      selectedLocation.address.countryCode === "UK"
        ? "GB"
        : selectedLocation.address.countryCode;
    setDefaultCountry(countryCode);
  }, [selectedLocation]);

  const handlePhoneChange = (value) => {
    setCartPhone(value);
    
    // Clear error when user is typing
    if (phoneError) {
      setPhoneError("");
    }
    
    // Validate phone number if value exists
    if (value) {
      // Use centralized validation utility with translation support
      const translations = {
        invalidFormat: transMsg("invalidPhoneFormat"),
        invalidLength: transMsg("invalidPhoneLength"),
        required: transMsg("phoneRequired"),
        tooShort: transMsg("phoneTooShort"),
        tooLong: transMsg("phoneTooLong"),
        invalidCountryCode: transMsg("invalidCountryCode")
      };
      
      const error = phoneValidation.getError(value, translations);
      if (error) {
        setPhoneError(error);
      }
    }
  };

  return (
    <>
      <PhoneInput
        placeholder={transMsg("phone")}
        value={cartPhone}
        onChange={handlePhoneChange}
        defaultCountry={defaultCountry || ""}
        error={phoneError ? "true" : undefined}
      />
      {phoneError && (
        <small className="text-danger mt-1 d-block">{phoneError}</small>
      )}
    </>
  );
};

export default UpdateCheckoutPhone;
